import { render } from "./Expositions.vue?vue&type=template&id=c021fafa&scoped=true"
import script from "./Expositions.vue?vue&type=script&lang=js"
export * from "./Expositions.vue?vue&type=script&lang=js"

import "./Expositions.vue?vue&type=style&index=0&id=c021fafa&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c021fafa"]])

export default __exports__